import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {AlertService} from "../services/alert.service";
import {AuthService} from "../services/auth.service";

@Component({
  selector: 'micro-objectGroup-detail',
  templateUrl: './objectGroup-detail.component.html'
})
export class ObjectGroupDetailComponent implements OnInit {
  @Input()
  objectGroupId:any;

  objectGroup:any;
  description:any;

  @Output()
  persisted:EventEmitter<any> = new EventEmitter<any>();

  constructor(private env: EnvService,
              private http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              public authService:AuthService,
              private alertService:AlertService) {
  }

  public ngOnInit(): void {
    if (this.objectGroupId) {
      this.load(this.objectGroupId);
    } else {
      this.route.params
        .subscribe((params: Params) => {
          let id:any = params['id'];
          if (id === '0') {
            this.createNew();
          } else {
            this.load(id);
          }
        });
    }
  }

  load(id:any) {
    this.http.get(`${this.env.e.url}/domain/objectGroups/${id}`).subscribe(
      data => {
        this.setObjectGroup(data)
      }
    );
  }

  setObjectGroup(objectGroup:any) {
    this.objectGroup = objectGroup;
  }

  createNew() {
    this.objectGroup = {
      items:[]
    };
  }

  save() {
    if (!this.objectGroup.id) {
      this.http.post(`${this.env.e.url}/domain/objectGroups`, this.objectGroup)
        .subscribe(
          data => {
            this.setObjectGroup(data)
            this.alertService.info(`Created ${this.objectGroup.name}`);
            this.persisted.emit({
              data: data,
              action: 'added'
            });
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/domain/objectGroups/${this.objectGroup.id}`, this.objectGroup)
        .subscribe(
          data => {
            this.setObjectGroup(data)
            this.alertService.info(`Updated`);
            this.persisted.emit({
              data: data,
              action: 'updated'
            });
          }
        );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/domain/objectGroups/${this.objectGroup.id}`)
      .subscribe(
        complete => {
          this.persisted.emit({
            data: this.objectGroup,
            action: 'deleted'
          });
          this.alertService.info(`Deleted ${this.objectGroup.name}`);
          if (!this.objectGroupId) {
            this.router.navigate(["/objectGroups"]);
          }
        }
      );
  }
}
